var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBurgermenu = function SvgIconBurgermenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "icon-burgermenu_svg__Lag_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 24 24"
    },
    viewBox: "4 5 14 14"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon-burgermenu_svg__st0{fill:none;stroke:#fff;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.7h13M5.5 12h13M5.5 16.3h13",
    className: "icon-burgermenu_svg__st0"
  })));
};
export default SvgIconBurgermenu;